import React, { useRef } from "react";
import Link from "next/link";
import { t } from "@helpers/translate";
import Icon from "../Icon";

interface Menu {
  name: string;
  slug: string;
}

interface Menus {
  items: Menu[];
}

const ScrollableMenu = ({ items }: Menus) => {
  const menuRef = useRef<HTMLDivElement>(null);

  const scrollLeft = () => {
    (menuRef.current as HTMLDivElement).scrollBy({
      left: -200,
      behavior: "smooth",
    });
  };

  const scrollRight = () => {
    (menuRef.current as HTMLDivElement).scrollBy({
      left: 200,
      behavior: "smooth",
    });
  };

  return (
    <div className="flex items-center py-4">
      <button className="scroll-button scroll-button-left" onClick={scrollLeft}>
        <Icon icon="arrowPrev" />
      </button>

      <div
        className="flex overflow-x-auto scroll-smooth w-4/5 mx-1"
        ref={menuRef}
      >
        {items.map((item: Menu, index: number) => (
          <div
            key={index}
            className="whitespace-nowrap h-8 w-auto border border-gray-200 bg-white text-gwg_dull_gray rounded-2xl px-3 py-2 text-xs"
          >
            <Link
              href={`/blog/category/${item.slug}`}
              title={t({
                id: "common.link.title",
                message: "GoWithGuide - Private Tours & Local Tour Guides",
              })}
              className="hover:underline text-gray-600"
            >
              {item.name}
            </Link>
          </div>
        ))}
      </div>

      <button className="scroll-button" onClick={scrollRight}>
        <Icon icon="arrowNext" />
      </button>
    </div>
  );
};

export default ScrollableMenu;
